const infoWindowRealtyTransactions = (payload, mr) => {
  const {
    building_name,
    address,
    construction_pattern,
    construction_year,
    use_type,
  } = payload;

  const formattingWord = (word) => {
    const formattedWord =
      word?.charAt(0).toUpperCase() + word?.toLowerCase()?.slice(1);
    return formattedWord;
  };

  const dynamicStyle = (word) => {
    if (word?.length > 40) {
      return '15px';
    }
    return '0';
  };

  return `
      <style>
      .full-container{
        font-family: Quicksand ,sans-serif;
        padding: 0 16px 16px 16px;
        width: 33rem;
        overflow: hidden;
      }
      .header {
        display: flex;
        align-items: center;
      }
      .header svg {
        margin-bottom: ${dynamicStyle(building_name)}
      }
      .header--title{
        color: #793EAD;
        font-weight: 700;
        font-size: 1.3em;
        max-width: 40ch;
        line-height: 1     
      }
      .header--address{
        color: #525A66;
        padding-top: 5px;
        max-width: 54ch;
        font-size: 0.844rem;
      }
      .header-container {
        display: flex;
        flex-direction: column;
        margin-left: 15px;
        padding: 15px 0;
      }
      .gm-ui-hover-effect{
        top: 10px!important;
        right: 15px!important;
      }
      .gm-ui-hover-effect span {
        width: 20px!important;
        height: 20px!important;
      }
      .body-container{
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        height: 10rem;
        padding-top: 20px;
        color: #525A66;
      }
      .info-container{
        display: flex;
        align-items: center;
        flex-flow: row nowrap;
      }
      .body-container--info-value{
        margin-left: 4px;
      }
      .body-container--info-key {
        font: normal 0.844rem 'Open Sans', sans-serif !important;
      }
      p.body-container--info-value {
        font: normal 0.844rem 'Open Sans', sans-serif !important;
      }
      strong {
        font: bold 0.844rem 'Open Sans', sans-serif !important;
      }
      .infowindow-button{
        background-color: #793EAD;
        color: #FFF;
        width: 100%;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        cursor: pointer;
        height: 2.3rem;
        border: none;
      }
      .infowindow-button:hover {
        transition: 0.2s;
        background-color: #3F205A;
      }
      </style>
     
<div class="full-container">
  <div class="header">
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="56" height="56" rx="28" fill="#F3F5F9"/>
      <path d="M34.7125 35.0642C29.7675 37.0086 24.7136 36.385 22.2177 33.6122C22.3123 34.175 22.4835 34.7189 22.7351 35.24C24.6358 39.1776 30.4816 40.3515 36.1838 38.1085L37.3973 40.6224L39.4938 34.615L33.4855 32.5189L34.7137 35.0631L34.7125 35.0642Z" fill="#BA96D9"/>
      <path d="M20.9845 20.8151C25.7725 18.5111 30.8587 18.76 33.5523 21.3411C33.4165 20.7868 33.2056 20.257 32.9163 19.7559C30.7301 15.9693 24.8136 15.23 19.2925 17.8876L17.8968 15.4702L16.2494 21.616L22.3959 23.2629L20.9834 20.8163L20.9845 20.8151Z" fill="#BA96D9"/>
      <path d="M30.3009 26.4218C29.5664 26.0273 28.6389 25.8733 27.6735 25.7378C27.3475 25.6922 27.2006 25.5621 27.1812 25.4858C27.1594 25.4001 27.2469 25.1742 27.5738 24.9327C28.4093 24.3157 29.6192 25.2911 29.6314 25.301L30.3261 24.4637L31.0259 23.6306C30.964 23.5787 30.3972 23.1136 29.5892 22.8119C29.4955 22.7769 29.4019 22.7466 29.3087 22.7187V22.0381H27.1327V22.7319C26.8327 22.837 26.5471 22.9861 26.2818 23.1819C25.2641 23.9331 24.812 24.9942 25.0722 26.0204C25.3235 27.0116 26.2046 27.7289 27.3716 27.8926C29.5825 28.2026 29.5482 28.4828 29.5049 28.8379C29.4853 28.9985 29.4179 29.2287 29.0609 29.374C28.4844 29.6081 27.4031 29.4897 26.3906 28.6758L25.0275 30.372C25.677 30.8939 26.402 31.2647 27.1329 31.4698V32.2817H29.3088V31.5653C29.5055 31.522 29.6968 31.4643 29.8805 31.3896C30.8868 30.9804 31.5371 30.1466 31.6648 29.1017C31.8085 27.923 31.3243 26.9711 30.3009 26.4218Z" fill="#BA96D9"/>
    </svg>
    <div class="header-container">
      <h6 class="header--title" data-cy="IWBuildingName${mr}">${building_name}</h6>
      <p class="header--address" data-cy="IWAddress${mr}">${address}</p>
    </div>
  </div>
  <div class="body-container">
    <div class="body-container--info">
      <div class="info-container">
        <p class="body-container--info-key" data-cy="IWRealtyTypeKey${mr}"><strong>Tipo de imóvel: </strong></p>
        <p class="body-container--info-value" data-cy="IWRealtyTypeValue${mr}">${formattingWord(
    construction_pattern
  )}</p>
      </div>
      <div class="info-container">
        <p class="body-container--info-key" data-cy="IWUseTypeKey${mr}"><strong>Tipo de uso: </strong></p>
        <p class="body-container--info-value" data-cy="IWUseTypeValue${mr}">${formattingWord(
    use_type
  )}</p>
      </div>
      <div class="info-container">
        <p class="body-container--info-key" data-cy="IWConstructionYearKey${mr}"><strong>Ano da construção: </strong></p>
        <p class="body-container--info-value" data-cy="IWConstructionYearValue${mr}">${construction_year}</p>
      </div>
    </div>


  </div>
</div>
</div>
    `;
};

export default infoWindowRealtyTransactions;
